/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Svc_Ai_App_Rescue_Scope_Output5Inputs */

const en_svc_ai_app_rescue_scope_output5 = /** @type {(inputs: Svc_Ai_App_Rescue_Scope_Output5Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Audit report`)
};

const ar_svc_ai_app_rescue_scope_output5 = /** @type {(inputs: Svc_Ai_App_Rescue_Scope_Output5Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`تقرير التدقيق`)
};

const bn_svc_ai_app_rescue_scope_output5 = /** @type {(inputs: Svc_Ai_App_Rescue_Scope_Output5Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`অডিট রিপোর্ট`)
};

const de_svc_ai_app_rescue_scope_output5 = /** @type {(inputs: Svc_Ai_App_Rescue_Scope_Output5Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Audit-Bericht`)
};

const es_svc_ai_app_rescue_scope_output5 = /** @type {(inputs: Svc_Ai_App_Rescue_Scope_Output5Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Informe de auditoría`)
};

const fr_svc_ai_app_rescue_scope_output5 = /** @type {(inputs: Svc_Ai_App_Rescue_Scope_Output5Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Rapport d'audit`)
};

const pt_svc_ai_app_rescue_scope_output5 = /** @type {(inputs: Svc_Ai_App_Rescue_Scope_Output5Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Relatório de auditoria`)
};

const zh_svc_ai_app_rescue_scope_output5 = /** @type {(inputs: Svc_Ai_App_Rescue_Scope_Output5Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`审计报告`)
};

const tr_svc_ai_app_rescue_scope_output5 = /** @type {(inputs: Svc_Ai_App_Rescue_Scope_Output5Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Denetim raporu`)
};

const ru_svc_ai_app_rescue_scope_output5 = /** @type {(inputs: Svc_Ai_App_Rescue_Scope_Output5Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Отчёт аудита`)
};

const pl_svc_ai_app_rescue_scope_output5 = /** @type {(inputs: Svc_Ai_App_Rescue_Scope_Output5Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Raport z audytu`)
};

/**
* | output |
* | --- |
* | "Audit report" |
*
* @param {Svc_Ai_App_Rescue_Scope_Output5Inputs} inputs
* @param {{ locale?: "en" | "ar" | "bn" | "de" | "es" | "fr" | "pt" | "zh" | "tr" | "ru" | "pl" }} options
* @returns {LocalizedString}
*/
const svc_ai_app_rescue_scope_output5 = /** @type {((inputs?: Svc_Ai_App_Rescue_Scope_Output5Inputs, options?: { locale?: "en" | "ar" | "bn" | "de" | "es" | "fr" | "pt" | "zh" | "tr" | "ru" | "pl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Svc_Ai_App_Rescue_Scope_Output5Inputs, { locale?: "en" | "ar" | "bn" | "de" | "es" | "fr" | "pt" | "zh" | "tr" | "ru" | "pl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "ar") return ar_svc_ai_app_rescue_scope_output5(inputs)
	if (locale === "bn") return bn_svc_ai_app_rescue_scope_output5(inputs)
	if (locale === "de") return de_svc_ai_app_rescue_scope_output5(inputs)
	if (locale === "es") return es_svc_ai_app_rescue_scope_output5(inputs)
	if (locale === "fr") return fr_svc_ai_app_rescue_scope_output5(inputs)
	if (locale === "pt") return pt_svc_ai_app_rescue_scope_output5(inputs)
	if (locale === "zh") return zh_svc_ai_app_rescue_scope_output5(inputs)
	if (locale === "tr") return tr_svc_ai_app_rescue_scope_output5(inputs)
	if (locale === "ru") return ru_svc_ai_app_rescue_scope_output5(inputs)
	if (locale === "pl") return pl_svc_ai_app_rescue_scope_output5(inputs)
	return en_svc_ai_app_rescue_scope_output5(inputs)
});
export { svc_ai_app_rescue_scope_output5 as "svc_ai-app-rescue_SCOPE_output" }